__webpack_require__.p = "https://bmidxbportugalplpreprod.netlify.app/";